export const timesheetsProjectLaborSummaryCapability = 'timesheets.project-labor-summary.v1';
export const timesheetsInsuranceClaimsReadinessProviderId = 'timesheets.server.insurance-claims-readiness';
//# sourceMappingURL=timesheets-insurance-claims-readiness.contract.js.map